export const FEATURE = {
  LINE_OFFICIAL_NOTIFICATION: 'line-official-notification',
  GPT: 'gpt',
  REF_LINK: 'ref-link',
  LINE_RICH_MENU: 'line-rich-menu',
  ALL_IN_ONE_CHAT_NEW: 'all-in-one-chat-new',
  FACEBOOK_SHOP: 'facebook-shop',
  EVENT_TRACKING: 'event-tracking',
  CUSTOMER_SUPPORT_SERVICE: 'customer-support-service',
  DISPLAY_NAME: 'display-name',
  ALL_IN_ONE_CHAT_WITH_TICKET_SALE_CONVERSION: 'all-in-one-chat-with-ticket-sale-conversion',
  ZERVA_BOOKING: 'zerva-booking',
  USER_STATE: 'user-state',
  RECURRING_NOTIFICATION: 'recurring-notification',
  UNLOCK_TIKTOK: 'unlock-tiktok'
}



// WEBPACK FOOTER //
// ./src/constants/feature.js